export default "__VITE_ASSET__37f50355__"